var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-item"},[_c('span',{staticClass:"data-item__value"},[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('span',{staticClass:"data-item__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }